var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-tile",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('div',{staticClass:"icon-circle"},[_c('img',{attrs:{"src":require(`@/assets/icons/navigation-menu/${_vm.icon}.svg`),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"text ri-small-body"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }